import { useLayoutEffect, useState } from "react";
import { useMediaQuery } from "./cv/utils/useMediaQuery";

type Theme = 'light' | 'dark';

export const useDarkMode: () => [Theme, () => void] = () => {
  const prefersLightMode = useMediaQuery("(prefers-color-scheme: light)");
  const [mode, setMode] = useState<Theme>(
    prefersLightMode ? "light" : "dark"
  );

  useLayoutEffect(() => {
    const isDark = mode === "dark";
    document.documentElement.classList.toggle("dark", isDark);
  }, [mode]);

  const toggleDarkMode = () => {
    setMode(mode === "light" ? "dark" : "light");
  };
  return [mode, toggleDarkMode];
};
